<template>
  <div class="cityList">
    <div class="cityContainer">
      <div class="icon" @click="goNext">
        <img src="../assets/images/wenhao.png" alt="" />
      </div>
      <div class="content">
        <div class="navLunbo">
          <ul>
            <li
              v-for="(item, index) in NavList"
              :key="index"
              :class="{ active: index == current }"
              @click="change(index)"
            >
              <div class="p">
                {{ item }}
                <div :class="{ xiahuaxian: index == current }"></div>
              </div>
            </li>
          </ul>
        </div>
        <div class="tips">
          <p>*具体线路以当地运营企业公布为准</p>
        </div>
        <div class="kunTongContent">
          <div class="newKuntong" v-show="current == 0">
            <div class="gongjiao">
              <div class="bus" @click="selGongjiao">
                <img
                  src="../assets/images/gongjiao2.png"
                  alt=""
                  v-show="gongjiaoSel"
                />
                <img
                  src="../assets/images/gongjiao1.png"
                  alt=""
                  v-show="gongjiaoUnsel"
                />
              </div>
              <div class="line" @click="selDitie">
                <img
                  src="../assets/images/rail1.png"
                  alt=""
                  v-show="ditieUnsel"
                />
                <img
                  src="../assets/images/rail2.png"
                  alt=""
                  v-show="ditieSel"
                />
              </div>
            </div>
            <div class="inCityList" v-show="Gongjiao">
              <ul class="leftSlide">
                <li
                  v-for="(item, index) in zhandian"
                  :key="index"
                  :class="{ active: currentGongjiao == index }"
                  @click="selNewGongjiao(index)"
                >
                  <div class="word">{{ item.privinceName }}</div>
                </li>
              </ul>
              <ul class="juti" id="newGongjiao">
                <li v-for="(item, index) in zhandian" :key="index">
                  <div class="privinceName">{{ item.privinceName }}</div>
                  <div class="cityAddrList">
                    <div
                      class="cityName"
                      v-for="city in item.cityName"
                      :key="city.index"
                    >
                      {{ city }}
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <div class="inCityList" v-show="Ditie">
              <ul class="leftSlide">
                <li
                  v-for="(item, index) in ditieZhandian"
                  :key="index"
                  :class="{ active: currentDitie == index }"
                  @click="selDitieCity(index)"
                >
                  <div class="word">{{ item.cityName }}</div>
                </li>
              </ul>
              <ul class="juti" id="ditie">
                <li v-for="(item, index) in ditieZhandian" :key="index">
                  <div class="privinceName">{{ item.cityName }}</div>
                  <div class="cityAddrList">
                    <div
                      class="cityName"
                      v-for="line in item.ditieLine"
                      :key="line.index"
                    >
                      {{ line }}
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="oldKuntong" v-show="current == 1">
            <div class="gongjiao">
              <img src="../assets/images/gongjiao2.png" alt="" />
            </div>
            <div class="inCityList">
              <ul class="leftSlide">
                <li
                  v-for="(item, index) in oldZhandian"
                  :key="index"
                  @click="selOldGongjiao(index)"
                  :class="{ active: currentOldGongjiao == index }"
                >
                  <div class="word">{{ item.privinceName }}</div>
                </li>
              </ul>
              <ul class="juti" id="oldGongjiao">
                <li v-for="(item, index) in oldZhandian" :key="index">
                  <div class="privinceName" v-show="!item.cityName.length == 0">
                    {{ item.privinceName }}
                  </div>
                  <div class="cityAddrList">
                    <div
                      class="cityName"
                      v-for="city in item.cityName"
                      :key="city.index"
                    >
                      {{ city }}
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { doRem } from "../utils/setrem";

export default {
  mounted() {},
  data() {
    return {
      ischeck: false,
      Gongjiao: true,
      Ditie: false,
      gongjiaoSel: true,
      gongjiaoUnsel: false,
      ditieUnsel: true,
      ditieSel: false,
      NavList: ["新昆通卡 (3104开头)", "老昆通卡 (2153开头)"],
      current: 0,
      currentGongjiao: 0,
      currentDitie: 0,
      currentOldGongjiao: 0,
      zhandian: [
        {
          privinceName: "江苏省",
          cityName: [
            "南京市",
            "无锡市（宜兴市、江阴市)",
            "徐州市（沛县、丰县、睢宁县、邳州市、新沂市）",
            "常州市（金坛市、溧阳市)",
            "苏州市（昆山市、常熟市、太仓市、张家港）",
            "南通市（海安市、海门市、如皋市、如东县、启东市）",
            "连云港市",
            "淮安市（盱眙县、涟水县、金湖县)",
            "盐城市（建湖县、阜宁县、东台市、射阳县、响水县、大丰市、滨海县）",
            "扬州市（江都市、宝应县、高邮市、仪征市)",
            "镇江市（丹阳市、句容市)",
            "泰州市（兴化市、靖江市、泰兴市)",
            "宿迁市（沐阳县、泗洪县、泗阳县)",
            // "昆山市",
            // "常熟市",
            // "江阴市",
            // "宜兴市",
            // "太仓市",
            // "张家港",
            // "吴江市",
          ],
        },
        {
          privinceName: "安徽省",
          cityName: [
            "合肥市",
            "蚌埠市",
            "滁州市（凤阳县、全椒县、来安县、定远县、明光市）",
            "淮南市",
            "阜阳市",
            "马鞍山市",
            "芜湖市（南陵县）",
            "淮北市",
            "六安市",
            "铜陵市",
            "池州市",
            "宿州市",
            "安庆市（部分线路）",
            "黄山市",
            "亳州市",
            "宣城市",
          ],
        },
        {
          privinceName: "重庆市",
          cityName: ["全部区域"],
        },
        {
          privinceName: "福建省",
          cityName: [
            "福州市（长乐市、连江县、永泰县、罗源县、福清市、闽清县、闽侯县）",
            "厦门市",
            "漳州市(漳浦县、平和县、东山县、长泰县、华安县、诏安县、云霄县、南靖县、龙海市、安达市)",
            "泉州市",
            "三明市",
            "莆田市",
            "南平市（邵武市、建瓯市、武夷山市、浦城县、光泽县、松溪县、顺昌县）",
            // "武夷山市(邵武市、建瓯市、武夷山市、浦城县、光泽县、松溪县、顺昌县)",
            "龙岩市（上杭县、武平县、漳平市、连城县、长汀县）",
            "宁德市（古田县、周宁县）",
            // "晋江市",
            "平潭综合实验区",
          ],
        },
        {
          privinceName: "甘肃省",
          cityName: [
            "武威市",
            "张掖市（山丹县、民乐县）",
            "兰州市（永登县、皋兰县、榆中县)",
            "白银市",
            // "华亭市",
            "金昌市",
            "酒泉市",
            "平凉市",
            "庆阳市（环县、正宁县、合水县）",
            "敦煌市",
            "陇南市（宕昌县、成县、文县）",
            "嘉峪关市",
            "定西市",
            "临夏回族自治州（部分线路）",
            "兰州新区",
            "甘南藏族自治州",
          ],
        },
        {
          privinceName: "广东省",
          cityName: [
            "中山市",
            "韶关市",
            "河源市",
            "惠州市",
            "江门市",
            "云浮市（郁南县、新兴县、罗定市）",
            "揭阳市",
            "肇庆市",
            "湛江市",
            "广州市",
            "深圳市",
            "珠海市",
            "东莞市",
            "潮州市",
            "汕尾市",
            "佛山市",
            "梅州市",
            "清远市",
            "阳江市",
            "茂名市",
            "汕头市",
          ],
        },
        {
          privinceName: "广西壮族自治区",
          cityName: [
            "南宁市",
            "北海市（涠洲岛、合浦县）",
            "防城港市（上思县、东兴市)",
            "钦州市（灵山县)",
            "贵港市（平南县、桂平县）",
            "玉林市",
            "柳州市（柳城县、鹿寨县、融安县、融水县、三江县）",
            "桂林市（阳朔县、灵川县、永福县、全州县、荔浦市、兴安县、灌阳县、平乐县、恭城县、龙胜各族自治县）",
            "百色市（靖西市、德保县、乐业县、凌云县、那坡县、田东县、田林县、田阳县、平果县）",
            "梧州市（岑溪市）",
            "贺州市（富川县、昭平县、钟山县）",
            "来宾市（合山市、忻城县、武宣县）",
            "崇左市（凭祥市、大新县、扶绥县、龙州县、宁明县、天等县）",
            "河池市",
          ],
        },
        {
          privinceName: "贵州省",
          cityName: [
            // "贵阳市",
            // " 黔南州（都匀市、福泉市、荔波县、三都县、独山县、瓮安县、龙里县、罗甸县)",
            // "遵义市",
            // "六盘水市",
            // "毕节市（大方县）",
            // "铜仁市",
            // "黔东南州（黄平县、施秉县、三穗县、岑巩县、天柱县、锦屏县、剑河县、台江县、黎平县、榕江县、从江县、雷山县、麻江县、丹寨县）",
            // "黔西南州（兴义市）",
            // "凯里市",
            "贵阳市",
            "遵义市",
            "六盘水市",
            "毕节市（大方县）",
            "铜仁市",
            "黔南布依族苗族自治州",
            "黔东南苗族侗族自治州（黄平县、施秉县、三穗县、岑巩县、天柱县、锦屏县、剑河县、台江县、黎平县、榕江县、从江县、雷山县、麻江县、丹寨县）",
            "黔西南布依族苗族自治州",
          ],
        },
        {
          privinceName: "海南省",
          cityName: ["海口市", "三亚市", "儋州市 ", "文昌市"],
        },
        {
          privinceName: "河南省",
          cityName: [
            "洛阳市（新安县、偃师市、宜阳县、嵩县、伊川县）",
            "平顶山市",
            "安阳市",
            "新乡市",
            "焦作市",
            "许昌市(禹州市、鄢陵市)",
            "商丘市",
            "信阳市",
            "驻马店市",
            "濮阳市",
            "开封市",
            "济源市",
            "南阳市",
            "漯河市",
            "三门峡市",
            "鹤壁市",
            "周口市",
            "郑州市",
            // "荥阳市",
            // "新郑市",
          ],
        },
        {
          privinceName: "河北省",
          cityName: [
            "石家庄市（正定县、深泽县、无极县、赵县、高邑县、元氏县、赞皇县、井陉县、平山县、灵寿县、行唐县、辛集市、晋州市、新乐市）",
            "承德市",
            "张家口市",
            "秦皇岛市",
            "唐山市",
            "廊坊市（香河县）",
            "保定市",
            "沧州市（萧宁县、任丘市）",
            "衡水市",
            "邢台市",
            "邯郸市",
          ],
        },
        {
          privinceName: "黑龙江省",
          cityName: [
            "哈尔滨市（九县市）",
            "齐齐哈尔市",
            "七台河市",
            "伊春市",
            "大兴安岭地区",
            "鸡西市",
            "鹤岗市",
            "双鸭山市",
            "大庆市",
            "佳木斯市",
            "牡丹江市",
            "黑河市",
            "绥化市",
          ],
        },
        {
          privinceName: "湖北省",
          cityName: [
            "武汉市",
            "荆门市",
            "黄石市",
            "咸宁市",
            "随州市",
            "潜江市",
            "十堰市（房县、竹山县、神农架）",
            "襄阳市",
            "宜昌市",
            "鄂州市",
            "黄冈市",
            "孝感市",
            "天门市",
            "荆州市",
            "恩施土家族苗族自治州",
            "仙桃市",
          ],
        },
        {
          privinceName: "湖南省",
          cityName: [
            "永州市（蓝山县、道县、宁远县）",
            "株洲市（醴陵市、株洲县、攸县、茶陵县、炎陵县）",
            "湘潭市（湘潭县、韶山市、湘乡市）",
            // "望城市",
            "张家界市（慈利县、桑植县）",
            "长沙市（长沙县、浏阳市、宁乡市）",
            "娄底市（涟源市、冷水江市、新化县、双峰县）",
            "怀化市（安江市、辰溪县、会同县、靖州县、麻阳县、通道县、溆浦县、沅陵县、芷江县、中方县）",
            "衡阳市（常宁市、耒阳市、祁东县、横山县、衡阳县、衡东县、衡南县）",
            "益阳市（沅江市、桃江县、南县、安化县、大通湖）",
            "常德市（安乡县、石门县、津市、澧县、汉寿县、桃源县）",
            "岳阳市（汨罗市、湘阴县、平江县、临湘市、华容县）",
            "邵阳市（邵东县、新邵县、邵阳县、隆回县、洞口县、绥宁县、城步苗族自治县、武冈市、新宁县）",
            "湘西土家族苗族自治州",
            "郴州市（资兴县、桂阳县、宜章县、永兴县、临武县、桂东县、汝城县、嘉禾县、安仁县）",
          ],
        },
        {
          privinceName: "吉林省",
          cityName: [
            "长春市（农安县、公主岭市）",
            "吉林市（永吉县、舒兰市、磐石市、蛟河市、桦甸市）",
            "四平市（双辽市、梨树县）",
            "辽源市",
            "通化市（集安市、柳河县、辉南县、梅河口市）",
            "白山市",
            "松原市（扶余市、长岭县、乾安县）",
            "白城市（镇赉县、通榆县、洮南市、大安市）",
            "延边朝鲜族自治州（珲春市、敦化市、和龙市、延吉市）",
            "长白山管委会（部分线路）",
          ],
        },
        {
          privinceName: "江西省",
          cityName: [
            "南昌市",
            "赣州市（南康市、瑞金市、信丰县、大余县、上犹县、崇义县、龙南县、全南县、于都县、寻乌县、石城县）",
            "吉安市",
            "鹰潭市",
            "九江市",
            "萍乡市",
            "宜春市",
            "上饶市",
            "新余市",
            "抚州市（部分线路）",
            "景德镇市",
          ],
        },
        {
          privinceName: "辽宁省",
          cityName: [
            "沈阳市",
            "营口市",
            "锦州市",
            "丹东市",
            "鞍山市",
            "盘锦市",
            "朝阳市",
            "铁岭市",
            "葫芦岛市",
            "大连市",
            "抚顺市",
            "辽阳市",
            // "兴城市",
            "本溪市",
            "阜新市",
          ],
        },
        {
          privinceName: "内蒙古自治区",
          cityName: [
            "呼和浩特市",
            "包头市",
            "乌海市",
            "鄂尔多斯市",
            "通辽市（部分线路）",
            "锡林郭勒盟（锡林浩特市、二连浩特市）",
            "呼伦贝尔",
            "巴彦淖尔市",
            "乌兰察布",
            "兴安盟",
            "阿拉善盟",
          ],
        },
        {
          privinceName: "宁夏回族自治区",
          cityName: [
            // "银川市", "固原市", "吴忠市", "石嘴山市"
            "银川市",
            "石嘴山市（平罗县）",
            "固原市",
            "吴忠市",
          ],
        },
        {
          privinceName: "青海省",
          cityName: [
            // "西宁市",
            // "海东市（互助县、民和县)",
            // "海西州（格尔木市、德令哈市)",
            // "玉树州",
            // "黄南藏族自治州",
            "西宁市",
            "海东市（互助县、民和县）",
            "黄南藏族自治州",
            "海西蒙古族藏族自治州（格尔木市、德令哈市）",
            "玉树藏族自治州",
          ],
        },
        {
          privinceName: "山东省",
          cityName: [
            "济南市",
            "青岛市",
            "烟台市",
            "枣庄市",
            "威海市",
            "临沂市",
            "德州市 ",
            "菏泽市",
            "滨州市",
            "聊城市",
            "济宁市",
            "潍坊市",
            "东营市",
            "淄博市",
            "泰安市",
            "日照市",
          ],
        },
        {
          privinceName: "山西省",
          cityName: [
            "阳泉市 ",
            "长治市",
            "晋中市",
            "忻州市",
            "临汾市 ",
            "运城市",
            "大同市 ",
            "晋城市 ",
            "朔州市",
            "吕梁市（临县、方山县、岚县、石楼县、兴县、中阳县、文水县、交城县、交口县、孝义县、柳林县、汾阳县）",
            "太原市",
          ],
        },
        {
          privinceName: "陕西省",
          cityName: [
            "西安市",
            "宝鸡市",
            "咸阳市",
            "铜川市",
            "渭南市",
            "延安市",
            "汉中市（宁强县、西乡县、镇巴县、略阳县、留坝县）",
            "榆林市（横山县、吴堡县、子洲县、府谷县、佳县）",
            "杨凌示范区",
            "安康市",
            "商洛市（部分线路）",
            "韩城市",
          ],
        },
        {
          privinceName: "上海市",
          cityName: ["全部区域"],
        },
        {
          privinceName: "北京市",
          cityName: ["全部区域"],
        },
        {
          privinceName: "四川省",
          cityName: [
            "成都市",
            "泸州市（无人售票）",
            "内江市（隆昌市） ",
            "绵阳市",
            "遂宁市",
            "乐山市（井研县、马边县、夹江县）",
            "南充市",
            "自贡市",
            // "江油市",
            // "阆中市",
            "攀枝花市",
            "德阳市",
            "宜宾市",
            "广安市",
            "达州市",
            "眉山市",
            "甘孜藏族自治州",
            "凉山彝族自治州",
            "广元市",
            "巴中市",
            "雅安市（天全县）",
            "资阳市",
          ],
        },
        {
          privinceName: "天津市",
          cityName: ["全部区域"],
        },

        {
          privinceName: "西藏自治区",
          cityName: ["拉萨市"],
        },
        {
          privinceName: "新疆维吾尔自治区",
          cityName: [
            // "乌鲁木齐市（部分线路）",
            // "哈密市",
            // "克拉玛依市",
            // "喀什地区",
            // "阿勒泰地区",
            // "伊犁哈萨克自治州",
            // "昌吉回族自治州",
            // "博尔塔拉蒙古自治州",
            // "巴音郭楞蒙古自治州",
            // "阿克苏地区",
            // "克孜勒苏柯尔克孜自治州",
            // "塔城地区",
            "乌鲁木齐市",
            "哈密市",
            "昌吉回族自治州",
            "博尔塔拉蒙古自治州",
            "巴音郭楞蒙古自治州",
            "阿克苏地区",
            "克孜勒苏柯尔克孜自治州",
            "喀什地区",
            "伊犁哈萨克自治州",
            "塔城地区",
            "阿勒泰地区",
          ],
        },
        {
          privinceName: "新疆生产建设兵团",
          cityName: [
            // "新疆兵团一师 阿拉尔市",
            // "新疆兵团十师 北屯市",
            // "新疆兵团十二师",
            // "新疆兵团第十三师（哈密地区）",
            "新疆生产建设兵团第一师",
            "新疆生产建设兵团第十师",
            "新疆生产建设兵团第十二师",
            "新疆生产建设兵团第十三师",
          ],
        },
        {
          privinceName: "云南省",
          cityName: [
            "昆明市",
            "楚雄彝族自治州 ",
            "玉溪市",
            "保山市",
            "文山壮族苗族自治州（文山市全部线路）",
            "大理白族自治州（大理市部分线路）",
            "曲靖市",
            "昭通市",
            "红河哈尼族彝族自治州",
            "丽江市",
            "迪庆藏族自治州",
            "西双版纳傣族自治州（勐腊县县城内线路）",
            "普洱市",
            "德宏傣族景颇族自治州（芒市部分线路）",
            "怒江傈僳族自治州",
            "临沧市",
          ],
        },
        {
          privinceName: "浙江省",
          cityName: [
            "杭州市",
            "温州市",
            "嘉兴市",
            "台州市",
            "绍兴市（新昌县、嵊州市、诸暨市）",
            "丽水市",
            "宁波市（象山县、余姚市、宁海市、慈溪市）",
            "衢州市",
            "湖州市",
            // "长兴市",
            "金华市",
            // "义乌市",
            "舟山市",
          ],
        },
        // {
        //   privinceName: "特别行政区",
        //   cityName: ["澳门"],
        // },
      ],

      ditieZhandian: [
        {
          cityName: "北京市",
          ditieLine: ["轨道交通路网全部线路"],
        },
        {
          cityName: "天津市",
          ditieLine: ["全部运营线路"],
        },
        {
          cityName: "石家庄",
          ditieLine: ["1号线", "2号线", "3号线"],
        },
        {
          cityName: "沈阳市",
          ditieLine: ["1号线", "2号线"],
        },
        {
          cityName: "大连市",
          ditieLine: ["1号线", "2号线", "3号线", "12号线", "13号线"],
        },
        {
          cityName: "长春市",
          ditieLine: ["1号线", "2号线", "3号线", "4号线", "8号线"],
        },
        {
          cityName: "哈尔滨市",
          ditieLine: ["1号线", "2号线", "3号线1期2期"],
        },
        {
          cityName: "上海市",
          ditieLine: ["全部运营线路"],
        },
        {
          cityName: "南京市",
          ditieLine: [
            "1号线",
            "2号线",
            "3号线",
            "4号线",
            "7号线（北段）",
            "10号线",
            "S1机场线",
            "S3宁天和际",
            "S6宁句城际",
            "S7宁潥线",
            "S8宁天城际",
            "S9宁高线",
          ],
        },
        {
          cityName: "无锡市",
          ditieLine: ["1号线", "2号线", "3号线", "1号线南延"],
        },
        {
          cityName: "徐州市",
          ditieLine: ["1号线"],
        },
        {
          cityName: "常州市",
          ditieLine: ["1号线", "2号线"],
        },
        {
          cityName: "苏州市",
          ditieLine: ["轨道交通全部线路"],
        },
        // {
        //   cityName: "淮安市",
        //   ditieLine: ["1号线"],
        // },
        {
          cityName: "南通市",
          ditieLine: ["1号线"],
        },
        {
          cityName: "杭州市",
          ditieLine: [
            "1号线",
            "2号线",
            "4号线",
            "5号线",
            "6号线",
            "7号线",
            "8号线",
            "9号线",
            "16号线",
          ],
        },
        {
          cityName: "宁波市",
          ditieLine: ["1号线", "2号线", "3号线", "4号线", "5号线"],
        },
        {
          cityName: "绍兴市",
          ditieLine: ["1号线"],
        },
        {
          cityName: "合肥市",
          ditieLine: ["1号线", "2号线", "3号线", "4号线", "5号线"],
        },
        {
          cityName: "芜湖市",
          ditieLine: ["1号线", "2号线"],
        },
        {
          cityName: "福州市",
          ditieLine: ["全部2条地铁线路"],
        },
        {
          cityName: "厦门市",
          ditieLine: ["全市所有轨道线路"],
        },
        {
          cityName: "南昌市",
          ditieLine: ["1号线", "2号线", "3号线", "4号线"],
        },
        {
          cityName: "济南市",
          ditieLine: ["1号线", "2号线", "3号线"],
        },
        {
          cityName: "青岛市",
          ditieLine: ["1号线", "2号线", "3号线", "8号线", "11号线", "13号线"],
        },
        {
          cityName: "郑州市",
          ditieLine: [
            "1号线",
            "2号线",
            "3号线",
            "4号线",
            "5号线",
            "6号线",
            "14号线",
            "城郊线",
          ],
        },
        {
          cityName: "洛阳市",
          ditieLine: ["1号线"],
        },
        {
          cityName: "长沙市",
          ditieLine: [
            "1 号线",
            "2号线",
            "3号线",
            "4号线",
            "5号线",
            "6号线",
            "磁浮快线",
          ],
        },
        {
          cityName: "广州市",
          ditieLine: [
            "1 号线",
            "2 号线",
            "3 号线",
            "4 号线",
            "5 号线",
            "6 号线",
            "7 号线",
            "8 号线",
            "9 号线",
            "13 号线",
            "14 号线",
            "18 号线",
            "21 号线",
            "APM 线",
            "广佛线",
            "海珠有轨1号线",
            "黄埔有轨1号线",
          ],
        },
        {
          cityName: "深圳市",
          ditieLine: [
            "1 号线",
            "2 号线",
            "3 号线",
            "4 号线",
            "5 号线",
            "6 号线",
            "7 号线",
            "8 号线",
            "9 号线",
            "10 号线",
            "11 号线",
          ],
        },
        {
          cityName: "佛山市",
          ditieLine: ["广佛线", "佛山地铁2号线"],
        },
        {
          cityName: "东莞市",
          ditieLine: ["2号线"],
        },
        {
          cityName: "南宁市",
          ditieLine: ["1号线", "2号线", "3号线", "4号线"],
        },
        {
          cityName: "重庆市",
          ditieLine: [
            "交通环线",
            "1号线",
            "2号线",
            "3号线（含空港线）",
            "4号线",
            "5号线",
            "6号线（含国博支线）",
            "9号线",
            "10号线",
          ],
        },
        {
          cityName: "成都市",
          ditieLine: [
            "1号线",
            "2号线",
            "3号线",
            "4号线",
            "5号线",
            "6号线",
            "7号线",
            "8号线",
            "9号线",
            "10号线",
            "17号线",
            "18号线",
            "有轨电车2号线",
          ],
        },
        {
          cityName: "贵阳市",
          ditieLine: ["1号线", "2号线"],
        },
        {
          cityName: "昆明市",
          ditieLine: ["1号线", "2号线", "3号线", "6号线"],
        },
        {
          cityName: "西安市",
          ditieLine: [
            "1号线",
            "2号线",
            "3号线",
            "4号线",
            "5号线",
            "6号线",
            "9号线",
            "西安北至机场城际铁路",
          ],
        },
        {
          cityName: "兰州市",
          ditieLine: ["1号线"],
        },
        {
          cityName: "乌鲁木齐市",
          ditieLine: ["1号线"],
        },
      ],
      oldZhandian: [
        {
          privinceName: "江苏省",
          cityName: [
            "无锡市",
            "南通市",
            "淮安市",
            "昆山市",
            // "常熟市",
            "江阴市",
            "宜兴市",
            "太仓市",
          ],
        },
        {
          privinceName: "安徽省",
          cityName: ["淮南市"],
        },
        {
          privinceName: "福建省",
          cityName: ["福州市", "泉州市"],
        },
        // {
        //   privinceName: "甘肃省",
        //   cityName: ["兰州市", "白银市", "华亭市"],
        // },
        {
          privinceName: "广东省",
          cityName: ["湛江市", "珠海市"],
        },
        {
          privinceName: "贵州省",
          cityName: ["遵义市"],
        },
        // {
        //   privinceName: "海南省",
        //   cityName: ["三亚市"],
        // },
        // {
        //   privinceName: "河北省",
        //   cityName: ["邯郸市"],
        // },
        {
          privinceName: "河南省",
          cityName: ["驻马店市", "漯河市", "郑州市", "荥阳市", "新郑市"],
        },
        {
          privinceName: "湖北省",
          cityName: ["十堰市"],
        },
        {
          privinceName: "湖南省",
          cityName: ["永州市"],
        },
        // {
        //   privinceName: "吉林省",
        //   cityName: ["辽源市", "松原市"],
        // },
        {
          privinceName: "江西省",
          cityName: ["南昌市", "赣州市", "鹰潭市", "九江市"],
        },
        {
          privinceName: "辽宁省",
          cityName: [
            "沈阳市",
            "营口市",
            "锦州市",
            "葫芦岛市",
            "抚顺市",
            "兴城市",
          ],
        },
        // {
        //   privinceName: "山东省",
        //   cityName: ["临沂市"],
        // },
        {
          privinceName: "陕西省",
          cityName: ["榆林市"],
        },
        {
          privinceName: "上海市",
          cityName: ["全部区域"],
        },
        {
          privinceName: "四川省",
          cityName: ["江油市"],
        },
        {
          privinceName: "天津市",
          cityName: ["全部区域"],
        },
        // {
        //   privinceName: "新疆维吾尔自治区",
        //   cityName: ["克拉玛依市"],
        // },
        // {
        //   privinceName: "新疆生产建设兵团",
        //   cityName: [],
        // },
        {
          privinceName: "云南省",
          cityName: ["昆明市"],
        },
        {
          privinceName: "浙江省",
          cityName: [
            "温州市",
            "嘉兴市",
            "台州市",
            "绍兴市",
            "宁波市",
            "湖州市",
            "长兴市",
            "金华市",
            "义乌市",
            "舟山市",
          ],
        },

        // {
        //   privinceName: "特别行政区",
        //   cityName: ["澳门"],
        // },
        {
          privinceName: "澳门",
          cityName: ["全部区域"],
        },
      ],
    };
  },
  methods: {
    getHeight() {
      let a = window.screen.availHeight;

      let b =
        document.querySelector(".inCityList").offsetTop -
        document.documentElement.scrollTop;
      document.querySelector(".inCityList").style.height = a - b + "px";
    },
    goNext() {
      this.$router.push("/OldNew");
    },
    scrollToByIndex1(index) {
      let parentDom = document.querySelector("#newGongjiao");
      let ch = parentDom.children;
      let currentLi = ch[index];
      let top = ch[0].offsetTop;
      if (currentLi) {
        parentDom.scrollTop = currentLi.offsetTop - top;
      }
    },
    scrollToByIndex2(index) {
      let parentDom = document.querySelector("#ditie");
      let ch = parentDom.children;
      let currentLi = ch[index];
      let top = ch[0].offsetTop;
      if (currentLi) {
        parentDom.scrollTop = currentLi.offsetTop - top;
      }
    },
    scrollToByIndex3(index) {
      let parentDom = document.querySelector("#oldGongjiao");
      let ch = parentDom.children;
      let currentLi = ch[index];
      let top = ch[0].offsetTop;
      if (currentLi) {
        parentDom.scrollTop = currentLi.offsetTop - top;
      }
    },
    goOld() {
      this.$router.push("OldNew");
    },
    selNewGongjiao(index) {
      this.currentGongjiao = index;
      this.scrollToByIndex1(index);
    },
    selDitieCity(index) {
      this.currentDitie = index;
      this.scrollToByIndex2(index);
    },
    selOldGongjiao(index) {
      this.currentOldGongjiao = index;
      this.scrollToByIndex3(index);
    },

    change(index) {
      this.current = index;
      console.log(1);
    },
    selGongjiao() {
      this.gongjiaoSel = true;
      this.gongjiaoUnsel = false;
      this.ditieSel = false;
      this.ditieUnsel = true;
      this.Gongjiao = true;
      this.Ditie = false;
    },
    selDitie() {
      this.ditieSel = true;
      this.ditieUnsel = false;
      this.gongjiaoSel = false;
      this.gongjiaoUnsel = true;

      this.Ditie = true;
      this.Gongjiao = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../style/CityList.scss";
</style>